import {DATA_TYPES, VIEW_TYPES} from "./fieldTypes";

export const FACILITY_FIELDS = [
    {
        name: "name",
        key: "name",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "NAME",
        modes: ["create", "update"],
        requiredForCreate: true,
        editableByRepTypeIds: [1, 2],
        selfEditable: true,
    },
    {
        name: "businessUnitCode",
        key: "businessUnitCode",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.SINGLE_SELECT,
        label: "Business Unit",
        modes: ["create", "update"],
        requiredForCreate: true,
        editableByRepTypeIds: [1, 2],
        selfEditable: true,
    },
    {
        name: "bookable",
        key: "bookable",
        dataType: DATA_TYPES.BOOLEAN,
        viewType: VIEW_TYPES.CHECKBOX,
        defaultValue: true,
        label: "BOOKABLE",
        modes: ["create", "update"],
        requiredForCreate: false,
        editableByRepTypeIds: [1, 2],
        selfEditable: true,
    },
    {
        name: "country",
        key: "country",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.SINGLE_SELECT,
        label: "COUNTRY",
        modes: ["create", "update"],
        requiredForCreate: true,
        editableByRepTypeIds: [1, 2],
        selfEditable: true,
    },
    {
        name: "city",
        key: "city",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "CITY",
        modes: ["create", "update"],
        requiredForCreate: true,
        editableByRepTypeIds: [1, 2],
        selfEditable: true,
    },
    {
        name: "state",
        key: "state",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.SINGLE_SELECT,
        label: "STATE",
        modes: ["create", "update"],
        requiredForCreate: true,
        editableByRepTypeIds: [1, 2],
        selfEditable: true,
    },
    {
        name: "address1",
        key: "address1",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "ADDRESS 1",
        modes: ["create", "update"],
        requiredForCreate: false,
        editableByRepTypeIds: [1, 2],
        selfEditable: true,
    },
    {
        name: "address2",
        key: "address2",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "ADDRESS 2",
        modes: ["create", "update"],
        requiredForCreate: false,
        editableByRepTypeIds: [1, 2],
        selfEditable: true,
    },
    {
        name: "postalCode",
        key: "postalCode",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.TEXT,
        label: "POSTAL CODE",
        modes: ["create", "update"],
        requiredForCreate: true,
        editableByRepTypeIds: [1, 2],
        selfEditable: true,
    },
    {
        name: "golferOrderActionTypeName",
        key: "golferOrderActionTypeName",
        dataType: DATA_TYPES.STRING,
        viewType: VIEW_TYPES.SINGLE_SELECT,
        label: "GOLFER ORDER ACTION TYPE NAME",
        modes: ["create", "update"],
        requiredForCreate: false,
        editableByRepTypeIds: [1, 2],
        selfEditable: true,
    },
];
